import { i18n } from '@/locales';
const lc = 'views.store_management_detail.';
export const detailPages = [
    {
        pageType: 'basic-info',
        title: i18n.t(`${lc}basic_info`),
        confirmTitle: i18n.t(`${lc}cancel_edit_basic_info`),
    },
    {
        pageType: 'management-fee',
        title: i18n.t(`${lc}management_fee`),
        confirmTitle: i18n.t(`${lc}cancel_edit_management_fee`),
    },
    {
        pageType: 'reception-operation',
        title: i18n.t(`${lc}reception_operation`),
        confirmTitle: i18n.t(`${lc}cancel_edit_reception_operation`),
    },
];
